import React, { useState, useEffect } from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ResponsiveContainer,
    LabelList,
} from "recharts";

import {
    compareMonthLabels,
    earliestYearMonth,
    getMonthLabelsInRange,
} from "../../utils/monthRange";
import CustomLabel from "./CustomLabel";
import CustomTooltip from "./CustomTooltip";

const BookingsStackedBarChart = ({ props, onLoad, onDataStart, startMonth, endMonth }) => {
    const [carrData, setCarrData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchMetrics = () => {
        setIsLoading(true);
        props
            .fetchData("getstackedbooking")
            .then((data) => {
                const metricsData = data || [];
                // Backend month order depends on which product appears first; sort chronologically
                metricsData.sort((a, b) => compareMonthLabels(a.month, b.month));
                setCarrData(metricsData);
                if (onDataStart) onDataStart(earliestYearMonth(metricsData.map((d) => d.month)));
            })
            .catch((error) => console.error("Error fetching metrics:", error))
            .finally(() => {
                setIsLoading(false);
                if (onLoad) onLoad();
            });
    };

    useEffect(() => {
        fetchMetrics();
    }, []);

    const allowedMonths = getMonthLabelsInRange(startMonth, endMonth);
    const visibleData = carrData.filter((d) => allowedMonths.includes(d.month));

    return (
        <div className="mb-32">
            {isLoading ? (
                onLoad ? null : (
                    <h4 className="px-2 pt-8 text-center">Loading Bookings by Product...</h4>
                )
            ) : visibleData.length > 0 ? (
                <>
                    <h2>Bookings by Product</h2>
                    <div className="pt-1">
                        <ResponsiveContainer width="100%" height={400}>
                            <BarChart
                                data={visibleData}
                                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                            >
                                <XAxis dataKey="month" />
                                <YAxis
                                    type="number"
                                    domain={[0, 1250000]}
                                    allowDataOverflow={true}
                                    tickFormatter={(value) => value.toLocaleString()}
                                />
                                {/* <Tooltip formatter={(value) => value.toLocaleString()} /> */}
                                <Tooltip content={<CustomTooltip />} />
                                <Legend />
                                <Bar dataKey="NetLease" stackId="a" fill="#004b6e" />{" "}
                                {/* Deep Navy Blue */}
                                <Bar dataKey="NetAsset" stackId="a" fill="#2f6f8f" />{" "}
                                {/* Slate Blue */}
                                <Bar dataKey="NetLessor" stackId="a" fill="#5b8fa9" />{" "}
                                {/* Muted Steel Blue */}
                                <Bar dataKey="NetClose" stackId="a" fill="#7da6b6" />{" "}
                                {/* Dusty Blue */}
                                <Bar dataKey="NetCash" stackId="a" fill="#a5bdc9" />{" "}
                                {/* Light Blue-Gray */}
                                <Bar dataKey="NetLoan" stackId="a" fill="#8c7264" />{" "}
                                {/* Professional Taupe */}
                                <Bar dataKey="Integrations" stackId="a" fill="#3e4c59" />{" "}
                                {/* Charcoal Gray */}
                                <Bar dataKey="Other" stackId="a" fill="#6c7a89" /> {/* Cool Gray */}
                                <Bar dataKey="Procure to Pay" stackId="a" fill="#587b7f" />
                                {/* Steel Teal */}
                                <Bar dataKey="Clients & Other" stackId="a" fill="#95a5a6" />
                                {/* Classic Silver Gray */}
                                <Bar dataKey="Firms" stackId="a" fill="#b8c2cc" />{" "}
                                {/* Light Corporate Gray */}
                                <Bar
                                    dataKey="Total Bookings"
                                    label={<CustomLabel data={visibleData} />}
                                    fill="transparent"
                                    isAnimationActive={false}
                                ></Bar>
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </>
            ) : (
                <h3 className="px-2 pt-8 text-center">No metrics available.</h3>
            )}
        </div>
    );
};

export default BookingsStackedBarChart;
